import { Request, Response } from 'express';

/** url-utils IOjb */
interface IOjb {
	[index: string]: string;
}

/** url-utils IPairsObj */
interface IPairsObj {
	[index: number]: string;
}

/**
 * 获取query参数
 * @param  {string} name 需要获取的参数key值
 * @return {[type]}      [description]
 */
export function getUrlParams(name: string, searchParam?: string): any {
	let search: any = searchParam.match(/\?.*(?=\b|#)/);

	// tslint:disable-next-line:no-unused-expression
	search && (search = search[0].replace(/^\?/, ''));
	if (!search) return name ? '' : {};
	let queries: any = {};
	let params: any = search.split('&');

	// tslint:disable-next-line:forin
	for (let i in params) {
		let param: any = params[i].split('=');
		queries[param[0]] = param[1] ? decodeURIComponent(param[1]) : '';
	}

	return name ? queries[name] : queries;
}

/***
 * / 获取对象的指定key值
 */
export function getVal(obj: any, query: string, defaultValue: any): any {
	if (obj === null || !(typeof obj === 'object')) {
		let realType: any = obj === null ? 'null' : typeof obj;
		console.error(`[getVal]: parameter obj's type should be 'object', but it is ${realType}`);

		return defaultValue;
	}
	if (typeof query !== 'string') {
		throw new Error(`[getVal]: parameter query's should be string, but it is ${typeof query}`);
	}
	const keys: any = query.split('.');
	let valObj: any = obj;
	for (let i: number = 0, len: number = keys.length; valObj && i < len; i++) {
		valObj = valObj[keys[i]];
	}
	if (!valObj) {
		return defaultValue;
	} else {
		return valObj;
	}
}

/**
 * 获取ip地址
 * @param {Request} req 请求对象
 * @returns
 */
export function getIp(req: Request): string {
	// return ((req.get('X-Real-Ip') || (req.headers && req.headers['x-forwarded-for']) || req.ip || '') as any).replace('::ffff:', '');
	return ((req.headers && (req.get('ali-cdn-real-ip') || req.get('x-forwarded-for') || req.get('X-Real-Ip') || req.get('x-forward-for'))) || req.ip || '').replace('::ffff:', '');
}

/**
 * 判断key是否在数组中
 * @Author   fisher<wangjiang.fly.1989@163.com>
 * @DateTime 2016-06-25T09:26:51+0800
 * @param    {[type]}                           arr [description]
 * @param    {[type]}                           key [description]
 * @return   {[type]}                               [description]
 */
export function indexOfArray(arrParam: any[], key: any): number | string {
	let arr: string[] = arrParam || [];
	for (let i: number = 0, len: number = arr.length; i < len; i++) {
		if (arr[i] === key) {
			return i;
		}
	}

	return -1;
}

/**
 * 给url注入参数，注入的参数会覆盖旧参数
 * */
export function fillParams(params: IOjb, urlParam: any, withouts: any): any {
	let url: string = urlParam || window.location.href;

	let urlPairs: string[] = url.split('#');
	let fullUrl: any = urlPairs[0];

	let hashUrl: any = (urlPairs.length > 1 && '#' + urlPairs[1]) || '';
	let baseUrl: string = fullUrl.split('?')[0];
	let originParams: IOjb = getUrlParams(null, fullUrl);

	let paramsList: string[] = [];
	let re: string = '';

	for (let key in originParams) {
		if (undefined === params[key] && indexOfArray(withouts, key) === -1) {
			paramsList.push(key + '=' + originParams[key]);
		}
	}

	for (let key1 in params) {
		if (indexOfArray(withouts, key1) === -1) {
			if (params[key1] !== undefined) {
				paramsList.push(key1 + '=' + params[key1]);
			}
		}
	}

	re += baseUrl;
	re += (paramsList.length && '?' + paramsList.join('&')) || '';
	re += hashUrl;

	return re;
}

/**
 * 是否是微信
 *
 * @export
 * @returns
 */
export function isWeixin(ua?: string): boolean {
	let _ua: string = ua || (typeof window === 'undefined' ? '' : window.navigator.userAgent || '');

	return /MicroMessenger/i.test(_ua);
}
